<template>
    <div id="chat" class="w-100">
        <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols" />

        <div class="header w-100 d-flex align-items-center justify-content-between">
            <div class="jj-eagle-fix d-flex align-items-center gap-3">
                <div class="back-button" @click="backButton()">
                    <span class="material-symbols-outlined">
                        arrow_back
                    </span>
                </div>

                <div class="thumb-title d-flex gap-3 justify-content-center">

                    <div class="thumb-container">
                        <div class="thumb" :style="`background: url(${thumb});`">
                        </div>
                    </div>
                    <div class="title-status d-flex flex-column justify-content-between">
                        <span class="title" :title="title">{{ title }}</span>
                        <div v-if="isGroup" class="status-container">
                            <div class="group-members">
                                <span :title="usersName">{{ usersName }}</span>
                            </div>
                        </div>
                        <div v-else class="status">

                            <div class="d-flex align-items-center gap-2">
                                <template v-if="status">
                                    <div class="online">
                                    </div>
                                    <span>{{ $t("notification.online") }}</span>
                                </template>
                                <template v-else>
                                    <div class="offline">
                                    </div>
                                    <span>{{ $t("notification.offline") }}</span>
                                </template>

                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div v-if="isGroup" class="hamburguer-menu">

                <div ref="actions_dropdown" class="ui right pointing suidropdown icon">
                    <span class="material-symbols-outlined">
                        more_vert
                    </span>
                    <div class="menu">
                        <div class="item d-flex align-items-center gap-3" @click="groupDetails()">
                            <span class="material-symbols-outlined">
                                more_horiz
                            </span>
                            {{ $i18n.t('notification.group.group_details') }}
                        </div>
                        <div v-if="!isGroupOwner" class="item d-flex align-items-center gap-3" @click="exitGroup()">
                            <span class="material-symbols-outlined">
                                group_remove
                            </span>
                            {{ $i18n.t('notification.exit_group') }}
                        </div>
                    </div>
                </div>

            </div>
            <div v-else class="close" @click="backButton()">
                <span class="material-symbols-outlined">
                    close
                </span>
            </div>
        </div>

        <div class="chat-container py-3">
            <div id="messages-wrap" class="messages-wrap d-flex flex-column" ref="messagesWrap" @scroll="onScroll">

                <div v-for="(message, index) in messages" :key="index" class="message-wrap">
                    <div v-if="message.is_system" class="is_system">
                        <div class="message-system-container">
                            <div class="message-system text-align">
                                {{ message.message }}
                            </div>
                        </div>
                    </div>

                    <div v-else-if="message.user.id != id" class="from-friend">
                        <div class="thumb-message d-flex align-items-center gap-2">
                            <div v-if="isGroup" class="thumb-container">
                                <div class="thumb" :style="`background: url(${message.user.avatar});`">
                                </div>
                            </div>
                            <p class="item-message" :class="{'is-group': isGroup}" v-html="message.message.replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                        </div>

                        <p class="item-name" v-if="message.user.nickname">
                            <template v-if="checkNextMessage(message)">
                                {{ message.user.nickname }} <span class="item-hour-message">{{ formHour(message.created_at) }}</span>
                            </template>
                        </p>
                    </div>
                    <div v-else class="from-me">

                        <div class="thumb-message d-flex align-items-center gap-2">
                            <p class="item-message" :class="{'is-group': isGroup}" v-html="message.message.replace(/(?:\r\n|\r|\n)/g, '<br>')"></p>
                            <div v-if="isGroup" class="thumb-container">
                                <div class="thumb" :style="`background: url(${message.user.avatar});`">
                                </div>
                            </div>
                        </div>
                        <p class="item-name" v-if="message.user.nickname">
                            <template v-if="checkNextMessage(message)">
                                {{ $t('notification.group.you') }} <span class="item-hour-message">{{ formHour(message.created_at) }}</span>
                            </template>
                        </p>
                    </div>
                    <div class="clear"></div>
                </div>
            </div>
        </div>


        <div class="send-message d-flex align-items-center py-3 gap-2">
            <div class="input-message flex-grow-1 w-100">
                <input type="text" ref="text_send_message" :placeholder="$t('notification.group.send_message')"
                       @keyup.enter="sendMessage()"/>
            </div>

            <span class="material-symbols-outlined send-icon" @click="sendMessage()">
                send
            </span>

        </div>




    </div>
</template>

<script>

let emitter = require('tiny-emitter/instance');

import { mapGetters } from 'vuex';

export default {
    name: "Chat",
    props: {
        data: [],
    },
    data() {
        return {
            title: '',
            thumb: '',
            isGroup: false,
            isGroupOwner: false,
            groupInfo: [],
            status: false,
            messages: [],
            is_loading: true,   // pagination: para checar se está carregando mais mensagens
            is_end: false,      // pagination: para checar se chegou ao fim do total de mensagens
            usersName: '',
            recipientId: '',
            offset: 0,
        }
    },
    beforeMount() {
        console.log("beforeMount Chat", this.data);

        let vm = this;
        vm.title      = vm.data.title;
        vm.thumb      = vm.data.thumb;
        vm.isGroup    = vm.data.isGroup;
        vm.recipientId = vm.data.recipientId;

        // Load messages
        vm.paginateMessages();

    },
    mounted() {

        const vm = this;

        window.$(this.$refs.actions_dropdown).suidropdown({});

        emitter.on("Chat::private_message::received", () => {

            vm.paginateMessages(true);

        });
    },
    methods: {
        sendMessage() {

            const vm = this;

            const message = this.$refs['text_send_message'].value;
            if(message.length === 0) {
                return;
            }

            let payload = {
                'event_id': vm.event_id,
                'message': this.$refs['text_send_message'].value
            }
            vm.$refs['text_send_message'].value = '';

            if(vm.isGroup){
                payload.group = vm.data.recipientId;
            } else {
                payload.friend = vm.data.recipientId;
            }

            vm.$store.dispatch("Friends/sendMessage", payload)
                .then(response => {

                    vm.messages.push(response.message);
                    vm.messages = vm.sortMessages(vm.messages);
                })
                .catch(error => {
                    console.log("error: ", error);
                })
                .finally(() => {
                    vm.scrollToBottom();
                });

        },
        checkNextMessage(message) {

            const msgIndex = this.messages.findIndex(msg => msg.id === message.id);

            // Verifique se existe uma próxima mensagem no mesmo grupo e se é do mesmo usuário
            const nextMessage = this.messages[msgIndex + 1];
            return !(nextMessage && nextMessage.user && nextMessage.user.id === message.user.id);
        },
        formHour(hour) {
            const options = {
                hour: '2-digit',
                minute: '2-digit',
            };
            return new Date(hour).toLocaleTimeString(this.langForDate, options);
        },
        sortMessages(messages) {
            // Ordenar mensagens pela data (antiga para recente)
            messages.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));

            // Preparar a lista de mensagens com separação de datas
            let groupedMessages = [];
            let addedDates = new Set(); // Mantém controle das datas já adicionadas

            messages.forEach(message => {
                const messageDate = new Date(message.created_at).toLocaleDateString('pt-BR');

                // Se a data ainda não foi adicionada, insira uma mensagem de sistema
                if (!addedDates.has(messageDate)) {
                    groupedMessages.push({
                        is_system: true,
                        is_date_message: true,
                        message: this.formatDate(message.created_at),
                        created_at: message.created_at
                    });
                    addedDates.add(messageDate); // Marque a data como adicionada
                }

                // Adicionar a mensagem original
                if(!message.is_date_message) {
                    groupedMessages.push(message);
                }

            });

            return groupedMessages;
        },
        loadMessagesScroll() {
            let vm = this;

            let payload = {
                "friend": vm.data.recipientId
            };
            if (vm.isGroup) {
                payload = {
                    "group": vm.data.recipientId
                };
            }

            payload.offset = vm.offset;

            vm.is_loading = true;
            vm.$store.dispatch("Friends/loadPmInbox", payload)
                .then(response => {

                    vm.messages = [
                        ...vm.messages,
                        ...response.messages
                    ];

                    vm.messages = vm.sortMessages(vm.messages);

                    vm.is_end = response.pagination.is_end;

                    vm.offset = response.pagination.offset;

                    // Mover a barra de scroll 10% abaixo
                    const messagesWrap = vm.$refs.messagesWrap;
                    if (messagesWrap) {
                        const moveBy = messagesWrap.scrollHeight * 0.25; // Calcula 10% do scroll total
                        messagesWrap.scrollBy(0, moveBy); // Move o scroll para baixo
                    }

                    if (vm.isGroup) {
                        vm.usersName = response.recipient.users.map(user => user?.name).join(', ');
                    } else {
                        vm.status = vm.getFriendStatus();
                    }

                })
                .finally(() => {
                    vm.is_loading = false;
                });
        },
        paginateMessages(isReceivingMessage = false) {
            let vm = this;

            let payload = {
                "friend": vm.data.recipientId
            };
            if (vm.isGroup) {
                payload = {
                    "group": vm.data.recipientId
                };
            }

            if (!isReceivingMessage) {
                payload.offset = vm.offset;
            } else {
                payload.offset = 0;
            }

            vm.is_loading = true;

            vm.$store.dispatch("Friends/loadPmInbox", payload)
                .then(response => {


                    console.log('#### response => ', response);
                    vm.messages = vm.sortMessages(response.messages);

                    vm.is_end = response.pagination.is_end;

                    if (!isReceivingMessage) {
                        vm.offset = response.pagination.offset;
                    }

                    vm.scrollToBottom();


                    if (vm.isGroup) {
                        vm.usersName = response.recipient.users.map(user => user?.name).join(', ');
                        vm.isGroupOwner = response.recipient.user_id === vm.id;
                        vm.groupInfo = response.recipient;
                    } else {
                        vm.status = vm.getFriendStatus();
                    }


                })
                .finally(() => {
                    vm.is_loading = false;
                });
        },
        formatDate(date) {

            const lang = this.$i18n.locale.toLowerCase(); // Normaliza o idioma

            // Formatar a data no formato desejado
            let dateKey = new Intl.DateTimeFormat(lang, {
                weekday: 'long',
                day: '2-digit',
                month: 'short'
            }).format(new Date(date));

            // Capitalizar o mês e remover o "de"
            dateKey = dateKey
                // .replace(/\b\p{L}/gu, match => match.toUpperCase()) // Capitaliza
                .replace(/\b\p{L}/gu, match => match) // Capitaliza
                .replace(/\sde\s/gi, ' '); // Remove o "de"

            return dateKey;
        },
        onScroll(e) {
            const { scrollTop } = e.target;

            if (scrollTop <= 85 && !this.is_loading && !this.is_end) {
                this.loadMessagesScroll();
            }
        },
        backButton() {

            emitter.emit('MenuCreateGroup::backButton', { tab: 'tabInbox'});

        },
        scrollToBottom() {
            this.$nextTick(() => {
                const messagesWrap = this.$refs.messagesWrap;
                if (messagesWrap) {
                    messagesWrap.scrollTop = messagesWrap.scrollHeight;
                }
            });
        },
        getFriendStatus() {
            const vm = this;

            // Todas as mensagens agrupadas em uma lista só
            const allMessages = Object.values(vm.messages);

            // Encontra a última mensagem enviada pelo amigo
            const lastFriendMessage = allMessages.reverse().find(message => message.user.id !== vm.id);

            // Retorna o status do amigo
            if(lastFriendMessage && lastFriendMessage.user) {
                return lastFriendMessage.user.online;
            }

            // Se não achar, retorna false por padrão
            return false;
        },
        exitGroup() {
            const vm = this;

            const payload = {
                group_id: vm.data.recipientId
            }

            vm.$store.dispatch("Friends/exitGroup", payload)
                .then(() => {
                    vm.backButton();
                })
                .catch(error => {
                    console.log("error: ", error);
                });
        },
        groupDetails() {

            emitter.emit('Chat::open::details_edit_group', this.groupInfo);

        }
    },
    computed: {
        ...mapGetters([
            'id', 'event_id'
        ])
    },
    beforeDestroy() {
        emitter.off("Chat::private_message::received");
    }
}
</script>

<style scoped lang="scss">

#chat {
    height: 100%;
    max-height: 702px;


    .chat-container {

        height: 78%;
        // height: calc(100vh - 170px);


        .messages-wrap {
            // max-height: 53vh;
            max-height: 100%;
            display: flex;
            overflow-y: auto;
            overflow-x: hidden;
            padding: 0 5px;


            .message-system-container {
                text-align: center;
                border-bottom: 1px solid #e1e1e1;
                margin-bottom: 10px;
                .message-system {
                    text-align: center;
                    text-transform: capitalize;
                    color: #CCCBCB;
                    padding: 10px;

                    font-family: Open Sans, sans-serif;
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 21.79px;
                    text-align: center;
                    text-underline-position: from-font;
                    text-decoration-skip-ink: none;


                }
            }


            .message-wrap {
                width: 100%;

                .item-name {
                    margin: 3px 0 0 0;
                    color: #474747;
                    font-family: Open Sans, sans-serif;
                    font-size: 12px;
                    line-height: 16px;

                    .item-hour-message {
                        color: rgba(71, 71, 71, 0.5019607843);
                    }
                }
                .from-friend {
                    text-align: left;
                    float: left;
                    width: auto;
                    max-width: 75%;
                    margin: 5px 0;

                    .item-message {
                        color: #404040;
                        background: #E3E8E7;
                        border-radius: 20px 20px 20px 0px !important;
                        margin: 0;
                        word-break: break-word;
                        padding: 20px 28px 20px 28px;
                        font-family: Hanken Grotesk;
                        font-size: 16px;
                        line-height: 20px;
                        margin: 0 !important;

                        &.is-group {
                            border-radius: 0px 20px 20px 20px !important;
                        }

                    }
                }

                .from-me {
                    text-align: right;
                    float: right;
                    width: auto;
                    max-width: 75%;
                    margin: 5px 0;

                    .item-message {
                        color: #FFFFFF;
                        background: var(--buttons_color);
                        border-radius: 20px 20px 0px 20px !important;
                        word-break: break-word;
                        padding: 20px 28px 20px 28px;
                        font-family: Hanken Grotesk;
                        font-size: 16px;
                        line-height: 20px;
                        margin: 0 !important;

                        &.is-group {
                            border-radius: 20px 0px 20px 20px !important;
                        }

                    }


                }


                .thumb-container {

                    .thumb {
                        width: 36px;
                        height: 36px;

                        border-radius: 54px;
                        position: relative;
                        background-size: cover !important;
                        background-position: center !important;
                        background-repeat: no-repeat !important;
                        background-blend-mode: saturation;

                    }
                }



            }
        }


        .search-icon {
            color: #B1B1B1;
            font-weight: 400;
            font-size: 32px;
            line-height: 24px;


            font-variation-settings:
                'FILL' 1,
                'wght' 400,
                'GRAD' 0,
                'opsz' 24
        }
        .no-results {
            font-family: Open Sans, sans-serif;
            font-size: 16px;
            font-weight: 600;
            line-height: 24px;
            color: #696A70;
        }
        .no-user-found {
            font-family: Open Sans, sans-serif;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            color: #696A70;
        }

        .add-user, .remove-user {

            border: 1px solid var(--buttons_color);
            border-radius: 10px;
            padding: 11px 14px;

            .label {
                font-family: Exo, sans-serif;
                font-size: 14px;
                font-weight: 600;
                line-height: 19px;
            }

        }

        .add-user {
            background-color: var(--buttons_color);
            color: #FFFFFF;

            .person-add-icon {
                font-family: 'Material Icons';
                font-size: 20px;
                font-weight: 400;
                line-height: 24px;
                color: #FFFFFF;

                font-variation-settings:
                    'FILL' 1,
                    'wght' 400,
                    'GRAD' 0,
                    'opsz' 24
            }
        }

        .remove-user {

            color: var(--buttons_color);

            .person-remove-icon {
                font-family: 'Material Icons';
                font-size: 20px;
                font-weight: 400;
                line-height: 24px;

                font-variation-settings:
                    'FILL' 1,
                    'wght' 400,
                    'GRAD' 0,
                    'opsz' 24
            }
        }

        .thumb {
            width: 42px;
            height: 43px;
            border-radius: 54px;
            position: relative;
            background-size: cover !important;
            background-position: center !important;
            background-repeat: no-repeat !important;
            background-blend-mode: saturation;

        }

        overflow-y: scroll; /* ou auto para adicionar rolagem apenas quando necessário */
        -ms-overflow-style: none; /* Para ocultar no Internet Explorer e Edge */
        scrollbar-width: none; /* Para ocultar no Firefox */

        &::-webkit-scrollbar {
            display: none; /* Para ocultar no Chrome, Safari e Opera */
        }

    }

    .send-message {


        .input-message input {
            border: 1px solid #32323233;
            padding: 18px 24px;
            border-radius: 10px;
            width: 100%;
            color: #393939;

            &::placeholder {
                color: #3939394D;
            }
        }

        .send-icon {
            cursor: pointer;
            font-family: 'Material Icons';
            font-size: 30px;
            font-weight: 400;
            line-height: 22px;
            color: var(--buttons_color);

            font-variation-settings:
                'FILL' 1,
                'wght' 400,
                'GRAD' 0,
                'opsz' 24;

        }

    }

    .header {

        .back-button, .close {
            cursor: pointer;

            &:hover {
                opacity: 0.5;
            }

        }

        .thumb-title {

            .title-status {

                .group-members {

                    span {
                        display: inline-block;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        max-width: 250px;
                    }
                }
                .title {
                    font-family: Open Sans, sans-serif;
                    font-size: 18px;
                    font-weight: 700;
                    display: inline-block;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    max-width: 250px;
                }

                .status {

                    .online, .offline {
                        width: 8px;
                        height: 8px;
                        border-radius: 50%;
                    }

                    .online {
                        background-color: #10CD79;
                    }

                    .offline {
                        background-color: #DC0000;
                    }

                    span {
                        font-family: Open Sans, sans-serif;
                        font-size: 12px;
                        font-weight: 400;
                        line-height: 24px;
                        text-align: left;
                        text-underline-position: from-font;
                        text-decoration-skip-ink: none;

                    }

                }

            }

            .thumb-container {

                .thumb {
                    width: 49px;
                    height: 49px;

                    border-radius: 54px;
                    position: relative;
                    background-size: cover !important;
                    background-position: center !important;
                    background-repeat: no-repeat !important;
                    background-blend-mode: saturation;

                }
            }

            .back-button {
                cursor: pointer;
            }

            .material-symbols-outlined {
                font-variation-settings:
                    'FILL' 1,
                    'wght' 400,
                    'GRAD' 0,
                    'opsz' 24
            }
        }


        .hamburguer-menu {
            cursor: pointer;

            .menu {
                border-radius: 10px;

                .item {
                    cursor: pointer;

                    .material-symbols-outlined {

                        font-family: 'Material Icons';
                        font-size: 20px;
                        font-weight: 400;
                        line-height: 20px;
                        color: #393939;

                        font-variation-settings:
                            'FILL' 1,
                            'wght' 400,
                            'GRAD' 0,
                            'opsz' 24;
                    }

                    &:hover {
                        color: #FFFFFF;
                        background-color: var(--buttons_color);

                        .material-symbols-outlined {
                            color: #FFFFFF;
                        }

                        &:first-child {
                            border-radius: 10px 10px 0 0;
                        }

                        &:last-child {
                            border-radius: 0 0 10px 10px;
                        }

                    }
                }
                
            }

        }
    }


    .py-32 {
        padding-top: 32px !important;
        padding-bottom: 32px !important;
    }

    .py-24 {
        padding-top: 24px !important;
        padding-bottom: 24px !important;
    }

    // MOBILE
    @media only screen and (max-width: 768px) {
        .main_modal {
            width: 90% !important;
            height: 90% !important;
        }
        .messages-wrap {
            min-height: 72vh;
            max-height: 72vh;
        }
        @media only screen and (max-height: 700px) {
            .messages-wrap {
                min-height: 65vh;
                max-height: 65vh;
            }
        }
    }

}

#chat {
    .jj-eagle-fix{
        width: 100% !important;
        .thumb-title{
            width: 100% !important;
            .title-status{
                padding-right: 60px !important;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                .title{
                    max-width: none !important;
                    display: inline !important;
                }
                .status-container{
                    .group-members{
                        overflow: hidden;
                        text-overflow: ellipsis;
                        span{
                            display: inline !important;
                            max-width: none !important;
                        }
                    }
                }
            }
        }
    }
    .header{
        .hamburguer-menu{
            position: relative;
            right: 10px;
        }

    }
}

@media screen and (max-width: 600px) {
    #chat {
        .chat-container {
            height: calc(100vh - 170px);
        }
    }
}

</style>